import { UnauthorizedError } from "utils/request";

const authMiddleware = (store) => (next) => (action) => {
  // Don't process AbortError - these are expected when page is refreshed
  // and should not trigger any error handling or logout
  if (action.err && action.err.name === 'AbortError') {
    // Continue processing the action but skip error handling
    return next(action);
  }
  
  // Check if the action contains an error (after AbortError check)
  if (action.err instanceof UnauthorizedError) {
    // Dispatch the logout action
    store.dispatch({ type: "auth/logout" });
  }
  
  return next(action);
};

export default authMiddleware;

